import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const getCPAppointmentList = async (params) => {
    const data = await apiCall("post", apiEndPoints.USERAPPOINTMENTLIST, params);
    return data;
};

const getCPAppointmentListForAdmin = async (params) => {
    const data = await apiCall("post", apiEndPoints.USERAPPOINTMENTLISTFORADMIN, params);
    return data;
};

const CPAppointmentstatusUpdate = async (params) => {
    const data = await apiCall("post", apiEndPoints.USERAPPOINTMENTSTATUSUPDATE, params);
    return data;
};

const createCpAppointment = async (params) => {
    const data = await apiCall("post", apiEndPoints.CREATEUSERAPPOINTMENT, params);
    return data;
};

const editCpAppointment = async (params) => {
    const data = await apiCall("post", apiEndPoints.EDITUSERAPPOINTMENT, params);
    return data;
};


const appointmentService = {
    getCPAppointmentList,
    getCPAppointmentListForAdmin,
    CPAppointmentstatusUpdate,
    createCpAppointment,
    editCpAppointment
};

export default appointmentService;